(function ($) {
    $(document).ready(function() {

        const titlePoints = $('.agenturglossar-overview h2');

        titlePoints.each(function(index) {
            const currentTitlePoint = $(this);
            const nextTitlePoint = titlePoints.eq(index + 1);
            // create wrap <div>
            const wrapperDiv = $('<div class="wrap-point">');
            // Find all <p> between the current and the next <h3>
            currentTitlePoint.nextUntil(nextTitlePoint, 'p').appendTo(wrapperDiv);
            // Insert a wrapper <div> after the current <h3>
            const mainWrapper = $('<div class="item">').append(currentTitlePoint, wrapperDiv);
            // Let's create a wrapper <div> and insert all the points
            $('.agenturglossar-overview .wrap-items').append(mainWrapper);
        });

        // We show the whole section
        $('.agenturglossar-overview').animate({ opacity: 1 });

    });

})(jQuery);